/** @format */

import { combineReducers } from "redux";

import questionFormReducer from "./QuestionFormReducer";
import InterviewQuestionsReducer from "./InterviewQuestionsReducer";
import UserLocationReducer from "./UserLocationReducer";
import AuthReducer from "./AuthReducer";
import SkillTreeCacheReducer from "./SkillTreeCacheReducer";
import AppConfigReducer from "./AppConfigReducer";

export default combineReducers({
  questionFormReducer,
  interviewQuestions: InterviewQuestionsReducer,
  UserLocationReducer,
  auth: AuthReducer,
  skillTreeCache: SkillTreeCacheReducer,
  appConfig: AppConfigReducer,
});
